import './Banner.css';

function Banner () {
    // JSX
    return (
    <header className="banner">
        <img src="/imagens/banner.png" alt="Banner principal organo"/>
    </header>
    )
}

export default Banner